import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbToastModule, NgbProgressbarModule
} from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { FlatpickrModule } from 'angularx-flatpickr';
import { CountUpModule } from 'ngx-countup';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TranslateModule } from '@ngx-translate/core';
// Swiper Slider
import { SlickCarouselModule } from 'ngx-slick-carousel';

// import { LightboxModule } from 'ngx-lightbox';

// Load Icons
import { defineElement } from "@lordicon/element";
import lottie from 'lottie-web';

// Pages Routing
import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from "../shared/shared.module";
import { WidgetModule } from '../shared/widget/widget.module';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { ToastsContainer } from './dashboards/dashboard/toasts-container.component';
import { DashboardsModule } from "./dashboards/dashboards.module";
import { AppsModule } from "./apps/apps.module";
import { EcommerceModule } from "./ecommerce/ecommerce.module";
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { IncidentCreateComponent } from './incidents/incident-create.component';
import { IncidentListComponent } from './incidents/incident-list.component';
import { VehicleAssignmentComponent } from './incidents/vehicle-assignment.component';
import { CrewAssignmentComponent } from './incidents/crew-assignment.component';
import { VehicleListComponent } from './incidents/vehicle-list.component';
import { EmployeesComponent } from './incidents/employees/employees.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    DashboardComponent,
    ToastsContainer,
    IncidentCreateComponent,
    IncidentListComponent,
    VehicleAssignmentComponent,
    VehicleListComponent,
    CrewAssignmentComponent,
    EmployeesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbToastModule,
    NgbPaginationModule,
    NgbProgressbarModule,
    NgbModule,
    TranslateModule,
    NgSelectModule,
    FlatpickrModule.forRoot(),
    CountUpModule,
    NgApexchartsModule,
    LeafletModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    GoogleMapsModule,
    PagesRoutingModule,
    SharedModule,
    WidgetModule,
    SlickCarouselModule,
    // LightboxModule,
    DashboardsModule,
    AppsModule,
    EcommerceModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
